import React from 'react';
import { Modal, ModalBody } from '@flexisaf/flexibull2';
import ApplicantDetails from './ApplicantDetails';
import PropTypes from 'prop-types';

export const EditApplicantDetails = (props) => (
    <>
      <Modal open={props.open} style={{ padding: 0 }}>
        <ModalBody width="100%" height="100vh" margin="0">
          <ApplicantDetails
            onClose={props.close}
            {...props}
          />
        </ModalBody>
      </Modal>
    </>
  );

EditApplicantDetails.propTypes = {
  open: PropTypes.bool,
  close: PropTypes.func
};